import { useEffect } from 'react';
import useDefaultProvince from './useDefaultProvince';
import useIsNativeView from './useIsNativeView';
import { useRouter } from './useCustomRouter';

const useNativeDefaultProvince = () => {
  const router = useRouter();
  const isNativeView = useIsNativeView();

  const { saveDefaultProvince, saveDefaultCity } = useDefaultProvince();

  useEffect(() => {
    if (isNativeView) {
      const provinceCode = router.query?.provinceFromNative
        ? router.query.provinceFromNative
        : null;
      const cityCode = router.query?.cityFromNative ? router.query.cityFromNative : null;

      if (provinceCode) {
        saveDefaultProvince({
          provinceCode,
          fromBranchPage: router.pathname === '/[area]/[branch]' ? true : false,
        });
      }

      if (cityCode) {
        saveDefaultCity({
          cityCode,
          fromBranchPage: router.pathname === '/[area]/[branch]' ? true : false,
        });
      }
    }

    return;
  }, [isNativeView]);
};

export default useNativeDefaultProvince;
